import clsx from 'clsx';
import { format } from 'date-fns';
import React, { useState } from 'react';
import { FaFilePdf, FaTimes } from 'react-icons/fa';
import ReactModal from 'react-modal';
import { PDFViewer } from '../../PDFViewer';
ReactModal.setAppElement('[data-app]');
export const PreviousReport = (props) => {
    const { className, report: { updatedAt, planOfAction, path }, } = props;
    const [reportVisible, setReportVisible] = useState(false);
    const handleReportClick = (event) => {
        event.preventDefault();
        setReportVisible(true);
    };
    const onRequestClose = () => setReportVisible(false);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: clsx(className, 'border border-app-gray-line p-3 rounded-md') },
            React.createElement("time", { dateTime: updatedAt.toISOString(), className: "text-xxs block font-medium mb-2" }, format(updatedAt, 'M/dd/yy @ h:mm a')),
            React.createElement("p", { className: "text-sm mb-1" }, planOfAction),
            React.createElement("a", { href: path, className: "btn-xs btn-outline btn-rhythm", onClick: handleReportClick },
                React.createElement(FaFilePdf, null),
                "Report")),
        React.createElement(ReactModal, { isOpen: reportVisible, onRequestClose: onRequestClose, contentLabel: 'Patient report', overlayClassName: "bg-black bg-opacity-90 inset-0 fixed z-40", className: clsx('fixed z-50 inset-0 grid place-items-center overflow-auto max-h-screen p-4 focus:outline-none', className) },
            React.createElement(PDFViewer, { file: path ?? 'empty' }),
            React.createElement("button", { type: "button", "aria-label": "Close report", onClick: onRequestClose, className: "fixed z-50 top-0 right-0 w-10 h-10 flex items-center justify-center" },
                React.createElement("div", { className: "flex items-center w-6 h-6 justify-center rounded-full bg-black border-2 border-white" },
                    React.createElement(FaTimes, { className: "w-3 h-3 text-white" }))))));
};
